module.exports = __webpack_public_path__ + "img/horizontal_7_4_3009.294fd1d6.png";